import { Album } from '../types';

/**
 * Demo music data - hardcoded to appear as first item in music category
 * Features Nyx's "Concrete Rose" album
 */
export const demoMusic: Album[] = [
];

export default demoMusic;
